module.exports = __webpack_public_path__ + "img/98.851e0fa2.svg";